module.exports = __webpack_public_path__ + "assets/svg/Icons/32/break-yellow-c9c303.svg";